export default __webpack_public_path__ + "static/media/warning--limited-lighting-under-trees--g1.12866256.png";